require('./comparativeBar.scss');

const PropTypes = require('prop-types');

const React = require('react');
const classNames = require('classnames');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

class ComparativeBar extends React.Component {

    getPercentage(value, totalValue) {
        let percentage;
        if (totalValue < value && value > 0) { // When the value of "Disponible" is negative and greater than zero, the bar should be showing completed at 100%.
            percentage = 100;
        } else {
            const parsedValue = parseInt(value, 10);
            const parsedTotalValue = parseInt(totalValue, 10);
            percentage = (parsedValue/parsedTotalValue) * 100;
        }
        return percentage;
    }


    getWidthAndOffset(width = 0, offset = 0) {
        if (width === 0) {
          return {
            display: 'none'
          }
        } else {
          return {
              width: `${width}%`,
              left: `${offset}%`
          }
        }
    }

    wrapBar(bar, tooltipText) {
        if (tooltipText) {
            return (
                <OKTooltip
                    content={tooltipText}
                    offset={[0, -15]}
                    target={bar}
                />
            );
        } else {
            return bar;
        }
    }

    render() {
        const {
            firstValue,
            secondValue,
            totalValue,
            thirdValue,
            firstValueText,
            secondValueText,
            totalValueText,
            className,
            blue,
            blueBar,
            slim
        } = this.props;

        const firstPercentage = this.getPercentage(firstValue, totalValue);
        const secondPercentage = this.getPercentage(secondValue, totalValue);
        const thirdPercentage = this.getPercentage(thirdValue, totalValue);
        const firstBar = (
            <div
                className="comparative-bar__inner comparative-bar__second-value"
                style={this.getWidthAndOffset(secondPercentage, firstPercentage)}
            >
            </div>
        );
        const secondBar = (
            <div
                className="comparative-bar__inner comparative-bar__first-value"
                style={this.getWidthAndOffset(firstPercentage, 0)}
            >
            </div>
        );
        const backgroundBar = (
            <div
                className="comparative-bar__inner comparative-bar__background"
                style={this.getWidthAndOffset(thirdPercentage, secondPercentage + firstPercentage)}
            >
            </div>
        );

        const finalClass = classNames('comparative-bar', {
            'comparative-bar--blue-bar': blueBar,
            'comparative-bar--blue': blue,
            'comparative-bar--slim': slim
        }, className);

        return (
            <div className={finalClass}>
                <div className="comparative-bar__wrapper">
                    {this.wrapBar(backgroundBar, totalValueText)}
                    {this.wrapBar(firstBar, secondValueText)}
                    {this.wrapBar(secondBar, firstValueText)}
                </div>
            </div>
        );
    }
}

ComparativeBar.propTypes = {
    firstValue: PropTypes.number,
    secondValue: PropTypes.number,
    totalValue: PropTypes.number,
    thirdValue: PropTypes.number,
    firstValueText: PropTypes.string,
    secondValueText: PropTypes.string,
    totalValueText: PropTypes.string,
    className: PropTypes.string,
    blue: PropTypes.bool,
    blueBar: PropTypes.bool,
    slim: PropTypes.bool
};

ComparativeBar.defaultProps = {
    firstValue: 0,
    secondValue: 0,
    totalValue: 0,
    thirdValue: 0,
    blue: false,
    slim: false
}

module.exports = ComparativeBar;